<div *ngIf="ratingsCount" class="d-flex flex-row flex-wrap">
  <div *ngIf="ratingsCount" class="flex-auto flex-{{direction}} justify-content-start align-items-start">
    <div *ngIf="!large" class="ratings">
      <mat-icon *ngFor="let star of stars; let i=index;" class="mat-icon-sm">{{star}}</mat-icon>
    </div>
    <div *ngIf="large" class="ratings">
      <mat-icon *ngFor="let star of stars; let i=index;" class="mat-icon">{{star}}</mat-icon>
    </div>
  </div>
  <div class="flex-auto ml-2" *ngIf="showNumber && ratingsCount > 1">
    {{ratingsCount}} reviews
  </div>
  <div class="flex-auto ml-2" *ngIf="showNumber && ratingsCount === 1">
    {{ratingsCount}} review
  </div>
  <div class="flex-auto ml-2" *ngIf="showViewLink">
    <span class="view-link">View</span>
  </div>
</div>
